module.exports = __webpack_public_path__ + "358b570afb83e62fa2dd86a35f97a3aa.png";